import OpeningTimes, { ServicePoint, OpeningDays, ServicePointDetails } from './OpeningTimes';

export { ServicePoint, OpeningDays, ServicePointDetails };

export default OpeningTimes;
